<template>
	<div>
		<div class="content-header">
			<div class="container-fluid">
				<div class="row mb-2">
					<div class="col-sm-6">
						<h2 class="m-0 poppins-medium mb-2">
							<span>Webhook</span>
						</h2>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12 col-xl-12 pt-3">
				<div class="card">
					<div class="card-body py-4" v-if="verTest">
						<a href="#" @click.prevent="verTest = false" title="Regresar">
							<i class="fa fa-arrow-left"></i>
						</a>
						<hr>

						<template v-if="cargandoTest">
							<h4>Cargando...</h4>
						</template>
						<template v-else>
							<table class="table table-bordered mb-3 table_style">
								<thead class="thead-light">
									<tr>
										<th colspan="100%" class="text-center">Respuesta de la solicitud</th>
									</tr>
									<tr>
										<th>Campo</th>
										<th>Valor</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(v, i) in respuestaTest" :key="i">
										<td>{{ i }}</td>
										<td>{{ v }}</td>
									</tr>
								</tbody>
							</table>

							<table class="table table-bordered table_style">
								<thead class="thead-light">
									<tr>
										<th colspan="100%" class="text-center">Información de la solicitud</th>
									</tr>
									<tr>
										<th>Campo</th>
										<th>Valor</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(v, i) in infoTest" :key="i">
										<td>{{ i }}</td>
										<td>{{ v }}</td>
									</tr>
								</tbody>
							</table>
						</template>

					</div>
					<div class="card-body py-4" v-else>

						<form @submit.prevent="guardar">
							<div class="form-group">
								<label for="inputVinculo" class="col-sm-2 col-form-label">Enlace:</label>

								<input
									type="text"
									v-model="form.vinculo"
									class="form-control form-control-sm"
									:required="true"
									id="inputVinculo"
								>
							</div>
							<div class="form-group">
								
								<label for="txtEncabezado" class="col-sm-2 col-form-label">Encabezado (json):</label>

								<textarea
									id="txtEncabezado"
									rows="4"
									class="form-control"
									v-model="form.encabezado"
								></textarea>
							</div>

							<div class="form-group row mb-1">

								<div class="col-sm-6">
									<div class="form-check">
										<input
										class="form-check-input"
										type="checkbox"
										id="inputActivo"
										v-model="form.activo"
										true-value="1"
										false-value="0"
										>
										<label class="form-check-label" for="inputActivo">
											Activo
										</label>
									</div>
								</div>
								<div class="col-sm-6 text-right">
									<button
										type="button"
										class="btn btn-lg btn-secondary mr-1"
										v-if="reg !== ''"
										@click.prevent="limpiar"
									>
										<i class="fa fa-asterisk"></i>
										Nuevo
									</button>
									<button
										type="button"
										class="btn btn-lg btn-primary mr-1"
										v-if="reg !== ''"
										@click.prevent="testWebhook"
									>
										<i class="fa fa-check"></i>
										Probar
									</button>
									<button type="submit" class="btn btn-lg btn-primary btn-color-principal">
										<span
											class="spinner-border spinner-border-sm"
											role="status"
											aria-hidden="true"
											v-if="btnGuardar"
										></span>
										<i class="fa fa-save" v-else></i>
										<span class="sr-only" v-if="btnGuardar">
											{{ reg === '' ? 'Guardando...':'Actualizando...' }}
										</span>
										<span v-if="!btnGuardar">{{ reg === '' ? ' Guardar':' Actualizar' }}</span>
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<div class="card-footer text-muted p-1">
			<span v-if="inicio">Buscando...</span>
		</div>
		<div class="table-responsive" v-if="!inicio">
			<table class="table table-sm table_style">
				<thead class="thead-light">
					<tr>
						<th scope="col">#</th>
						<th scope="col">Enlace</th>
						<th scope="col">Encabezado</th>
						<th scope="col">Activo</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i, idx) in filtrada" :key="i.id">
						<th scope="row">{{ idx + 1 }}</th>
						<td><a href="#" @click.prevent="editar(idx)">{{ i.vinculo }}</a></td>
						<td>{{ i.encabezado }}</td>
						<td>{{ i.activo == 1 ? 'SI':'NO' }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import ManteAccion from '../mixins/ManteAccion.js';
	import axios from 'axios'
	export default {
		name: 'ManteGuiaWebhook',
		mixins: [ManteAccion],
		data: () => ({
			nombre: 'cliente_webhook',
			verTest: false,
			respuestaTest: '',
			infoTest: '',
			cargandoTest: false
		}),
		methods: {
			editar (idx) {
				let tmp = this.filtrada[idx];
				this.verTest = false

				this.reg = tmp.cliente_webhook;
				this.form = tmp;
				this.verForm = true;
			},
			testWebhook() {
				this.verTest = true
				this.cargandoTest = true
				axios.get(`${this.UrlBase}/webhook/test/${this.reg}`)
					.then(r => {
						this.respuestaTest = r.data.respuesta
						this.infoTest = r.data.info
					})
					.catch(e => {
						this.showWarnMsg({message: 'Error al probar: ' + e})
					})
					.finally(() => {
						this.cargandoTest = false
					})
			}
		},
		watch: {
			verTest() {
				this.respuestaTest = 'Realizando prueba, espere por favor...'
			}
		}
	}
</script>